
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["formatCodeApi"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "5538ff8e3248f006127d.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			